export class StaffDetail {
    plantillaId: number;
    companyId: number;
    attribute: string;
    year: string;
    month: string;
    tipo: string;
    plantilla: number;
    //acumulada: number;
    hombre: number;
    mujer: number;
    edad18: number;
    edad31: number;
    edad41: number;
    edad51: number;
    edad61: number;
}